module.exports = __webpack_public_path__ + "static/img/stay_informed_legally.051cac7e.png";